// src/redux/reducers/survey-management/beneficiarySurveyReducer.js
import {
  FETCH_BENEFICIARY_SURVEYS_REQUEST,
  FETCH_BENEFICIARY_SURVEYS_SUCCESS,
  FETCH_BENEFICIARY_SURVEYS_FAILURE,
} from "../../actions/survey-management/beneficiarySurveyActions";

const initialState = {
  loading: false,
  surveys: [],
  pagination: {
    page: 1,
    limit: 10,
    totalRecords: 0,
    totalPages: 0,
  },
  error: null,
};

const beneficiarySurveyReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BENEFICIARY_SURVEYS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_BENEFICIARY_SURVEYS_SUCCESS:
      return {
        ...state,
        loading: false,
        surveys: action.payload.data || [],
        pagination: action.payload.pagination || state.pagination,
        error: null,
      };

    case FETCH_BENEFICIARY_SURVEYS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default beneficiarySurveyReducer;
